import { makeAutoObservable, runInAction } from 'mobx'
import DriverService from '../../../../services/DriverService'

class CaselessPaymentSuccessStore {
  constructor () {
    this.isLoading = false
    this.faq = []

    makeAutoObservable(this)
    this.driverService = new DriverService()
  }

  async fetchFrequentlyAskedQuestions (operationId) {
    try {
      const faq = await this.driverService.fetchFAQ(operationId)

      runInAction(() => {
        this.faq = faq
        this.isLoading = false
      })

      return faq
    } catch (e) {
      runInAction(() => {
        this.isLoading = false
      })
    }
  }
}

export default CaselessPaymentSuccessStore
